import React, { useState, useEffect } from "react";
import {
  Form,
  Col,
  Row,
  Button,
  Select,
  Collapse,
  DatePicker,
  Input,
  Typography,
} from "antd";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import { odata } from "./Helper";
import RequestHandler from "util/RequestHandler";

const QuoteTableFilter = (props) => {
  const [form] = Form.useForm();
  const [projectStepSelect, setProjectStepSelect] = useState({
    data: [],
    loading: false,
  });
  const [projectStatusSelect, setProjectStatusSelect] = useState({
    data: [],
    loading: false,
  });

  const [firmSelect, setFirmSelect] = useState({
    data: [],
    loading: false,
  });

  const [purchaseRequestSelect, setPurchaseRequestSelect] = useState({
    data: [],
    loading: false,
  });

  useEffect(() => {
    getProjectStatus();
  }, []);

  const getProjectStatus = () => {
    setProjectStatusSelect({ data: [], loading: true });

    RequestHandler.get(`/Quote/GetEntityStatus`).then((res) => {
      setProjectStatusSelect({ data: res, loading: false });
    });
  };

  useEffect(() => {
    if (props.data) {
      form.setFieldsValue(props.data);
    }
  }, [props.data]);

  const onFinish = (values) => {
    {
      let query = "";
      const conditions = [];

      if (values.id) {
        conditions.push(`id eq ${values.id}`);
      }
      if (values.status !== undefined) {
        conditions.push(`statusByte eq ${values.status}`);
      }
      if (values.description) {
        conditions.push(odata.contains("description", values.description));
      }
      if (values.deliveryDate) {
        conditions.push(
          odata.dateCompareValueBefore(
            values.deliveryDate,
            "eq",
            "deliveryDate"
          )
        );
      }

      if (values.firmId) {
        conditions.push(`firmId eq ${values.firmId}`);
      }

      if (values.purchaseRequestId) {
        conditions.push(`purchaseRequestId eq ${values.purchaseRequestId}`);
      }

      if (values.addDate) {
        conditions.push(
          odata.dateCompareValueBefore(values.addDate, "eq", "addDate")
        );
      }

      if (conditions.length !== 0) {
        query = conditions.join(" and ");
      }

      if (props.onFinishFilter) props.onFinishFilter(query, values);
    }
  };

  const onStockSearch = (value) => {
    if (value.length >= 2) {
      setProjectStepSelect({ data: [], loading: true });

      RequestHandler.get(
        `/Quote?$select=id,name,description&$filter=(${odata.contains(
          "name",
          value
        )} or ${odata.contains("description", value)})`
      ).then((res) => {
        setProjectStepSelect({ data: res.value, loading: false });
      });
    } else {
      setProjectStepSelect({ data: [], loading: false });
    }
  };

  const clearFilter = () => {
    form.resetFields();

    if (props.onClearFilter) {
      props.onClearFilter();
    }
  };

  const onFirmSearch = (value) => {
    if (value.length >= 2) {
      setFirmSelect({ data: [], loading: true });

      RequestHandler.get(
        `/Firm?$select=id,firmBranchNumber,name&$filter=${odata.contains(
          "name",
          value
        )} or ${odata.contains("firmBranchNumber", value)}`
      ).then((res) => {
        setFirmSelect({ data: res.value, loading: false });
      });
    } else {
      setFirmSelect({ data: [], loading: false });
    }
  };

  const purchaseRequestSearch = (value) => {
    if (value.length >= 2) {
      setPurchaseRequestSelect({ data: [], loading: true });

      RequestHandler.get(
        `/PurchaseRequest?$select=id,name,description&$filter=(${odata.contains(
          "name",
          value
        )} or ${odata.contains("description", value)})`
      ).then((res) => {
        setPurchaseRequestSelect({ data: res.value, loading: false });
      });
    } else {
      setPurchaseRequestSelect({ data: [], loading: false });
    }
  };

  return (
    <Row id="filterArea" style={{ ...props.style }}>
      <Col span={24}>
        <Collapse>
          <Collapse.Panel
            header="Filtreleme için tıklayınız."
            extra={
              props.extraText ? (
                <Typography>
                  <Typography.Paragraph
                    style={{
                      marginBottom: 0,
                      fontSize: "80%",
                    }}
                    type="secondary"
                  >
                    {props.extraText}
                  </Typography.Paragraph>
                </Typography>
              ) : null
            }
          >
            <Form
              name="filter"
              form={form}
              initialValues={{
                remember: true,
              }}
              layout="vertical"
              onFinish={onFinish}
            >
              <Row style={{ flexDirection: "row" }}>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="id" label=" Teklif  Kodu :">
                    <Select
                      allowClear
                      showSearch
                      placeholder="En az 2 harf giriniz.."
                      onSearch={onStockSearch}
                      filterOption={(input, option) =>
                        option.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 ||
                        option.code
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                      loading={projectStepSelect.loading}
                    >
                      {projectStepSelect.data.map((item) => (
                        <Select.Option
                          key={item.id}
                          value={item.id}
                          description={item.description}
                        >
                          {item.name + " (" + item.description + ")"}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="description" label="Açıklama :">
                    <Input />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item label="Durum" name="status">
                    <Select
                      allowClear
                      showSearch
                      filterOption={(input, option) =>
                        option.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                      loading={projectStatusSelect.loading}
                    >
                      {projectStatusSelect.data.map((item) => (
                        <Select.Option key={item.id} value={item.id}>
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item label="Teslimat Tarihi" name="deliveryDate">
                    <DatePicker format="DD.MM.YYYY" style={{ width: "100%" }} />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="firmId" label="Proje :">
                    <Select
                      allowClear
                      showSearch
                      placeholder="En az 2 harf giriniz.."
                      onSearch={onFirmSearch}
                      filterOption={(input, option) =>
                        option.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 ||
                        option.code
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                      loading={firmSelect.loading}
                    >
                      {firmSelect.data.map((item) => (
                        <Select.Option
                          key={item.id}
                          value={item.id}
                          code={item.firmBranchNumber}
                        >
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="purchaseRequestId" label=" Talep Kodu :">
                    <Select
                      allowClear
                      showSearch
                      placeholder="En az 2 harf giriniz.."
                      onSearch={purchaseRequestSearch}
                      filterOption={(input, option) =>
                        option.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 ||
                        option.code
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                      loading={purchaseRequestSelect.loading}
                    >
                      {purchaseRequestSelect.data.map((item) => (
                        <Select.Option
                          key={item.id}
                          value={item.id}
                          description={item.description}
                        >
                          {item.name + " (" + item.description + ")"}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item label="Eklenme Tarihi" name="addDate">
                    <DatePicker format="DD.MM.YYYY" style={{ width: "100%" }} />
                  </Form.Item>
                </Col>
              </Row>

              <Row style={{ flexDirection: "row" }}>
                <Col span={24} style={{ textAlign: "right" }}>
                  <Button
                    danger
                    size="small"
                    icon={<CloseOutlined />}
                    onClick={() => clearFilter()}
                  >
                    Sıfırla
                  </Button>
                  <Button
                    type="primary"
                    size="small"
                    icon={<SearchOutlined />}
                    style={{ color: "#40a9ff", borderColor: "#40a9ff" }}
                    htmlType="submit"
                  >
                    Filtrele
                  </Button>
                </Col>
              </Row>
            </Form>
          </Collapse.Panel>
        </Collapse>
      </Col>
    </Row>
  );
};
export default QuoteTableFilter;
